import { Validators } from "@angular/forms";
import { validationRegex } from "@obg/ngx.global";

import { NationalDocuments } from "./national-document.model";

export const NATIONAL_DOCUMENTS: NationalDocuments = {
	GR: [
		{
			value: "NationalID",
			nameKey: "register.national-document.national-id",
			placeholderKey: "register.national-document.national-id.number",
			tooltipKey: "register.national-document.national-id.tooltip",
			documentNumberValidatorPrefix: "register.national-document.national-id",
			validators: [Validators.required, Validators.pattern(validationRegex.nationalId.hgc)],
		},
		{
			value: "NewNationalID",
			nameKey: "register.national-document.new-national-id",
			placeholderKey: "register.national-document.new-national-id.number",
			tooltipKey: "register.national-document.new-national-id.tooltip",
			documentNumberValidatorPrefix: "register.national-document.new-national-id",
			validators: [Validators.required, Validators.pattern(validationRegex.newNationalId.hgc)],
		},
		{
			value: "Passport",
			nameKey: "register.national-document.passport",
			placeholderKey: "register.national-document.passport.number",
			tooltipKey: "register.national-document.passport.tooltip",
			documentNumberValidatorPrefix: "register.national-document.passport",
			validators: [Validators.required, Validators.pattern(validationRegex.nationalId.hgc)],
		},
	],
	PE: [
		{
			value: "DNI",
			nameKey: "register.national-document.dni",
			placeholderKey: "register.national-document.dni.number",
			tooltipKey: "register.national-document.dni.tooltip",
			documentNumberValidatorPrefix: "register.national-document.dni",
			validators: [Validators.required, Validators.minLength(8), Validators.maxLength(8)],
		},
		{
			value: "Passport",
			nameKey: "register.national-document.passport",
			placeholderKey: "register.national-document.passport.number",
			tooltipKey: "register.national-document.passport.tooltip",
			documentNumberValidatorPrefix: "register.national-document.passport",
			validators: [Validators.required, Validators.minLength(9), Validators.maxLength(9)],
		},
		{
			value: "CE",
			nameKey: "register.national-document.ce",
			placeholderKey: "register.national-document.ce.number",
			tooltipKey: "register.national-document.ce.tooltip",
			documentNumberValidatorPrefix: "register.national-document.ce",
			validators: [Validators.required, Validators.minLength(9), Validators.maxLength(9)],
		},
	],
	PY: [
		{
			value: "DNI",
			nameKey: "register.national-document.dni",
			placeholderKey: "register.national-document.dni.number",
			tooltipKey: "register.national-document.dni.tooltip",
			documentNumberValidatorPrefix: "register.national-document.dni",
			validators: [Validators.required, Validators.minLength(6), Validators.maxLength(7)],
		},
		{
			value: "Passport",
			nameKey: "register.national-document.passport",
			placeholderKey: "register.national-document.passport.number",
			tooltipKey: "register.national-document.passport.tooltip",
			documentNumberValidatorPrefix: "register.national-document.passport",
			validators: [Validators.required],
		},
	],
};
